export const parseResult = (result) =>
  result && result.data && result.data.data;